export default {"src":"/_next/static/media/zest.542888cd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};